module.exports = __webpack_public_path__ + "static/media/achievement1.a3f732f8.png";